import { combineReducers } from "redux";
import { DeviceState } from "./DeviceReducer";

export const DeviceReducers = combineReducers({
    DeviceState : DeviceState
});

